import { FormikTextField } from "../../forms/Formik"
import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import type { BillReceiversFormValuesType } from "../billReceiverTypes"

type DebtorNumberFieldProps = Readonly<{
    isMerchantAdmin: boolean
}>

export function DebtorNumberField({ isMerchantAdmin }: DebtorNumberFieldProps) {
    if (!isMerchantAdmin) {
        return null
    }

    return (
        <LocalizedStrict id="bill-receivers-form-label-debtor-number" attrs={{ label: true, placeholder: true }}>
            <FormikTextField<BillReceiversFormValuesType>
                name="debtorNumber"
                label="Debtor number"
                placeholder="Identifier of debtor in your accounting system"
                fullWidth
            />
        </LocalizedStrict>
    )
}
